import { cn } from "@/utils/styles";
import React from "react";

export type TextInputProps = {
  value?: string;
  type?: string;
  disabled?: boolean;
  name: string;
  id?: string;
  placeholder?: string;
  className?: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  onPaste?: (e: React.ClipboardEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  error?: boolean;
  disabledOnWheel?: boolean;
  baseHOCClassName?: string;
  min?: number | string;
  step?: number | string;
  max?: number | string;
  maxLength?: number;
  rows?: number;
};

const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      onChange,
      value = "",
      name,
      id,
      placeholder,
      type = "text",
      className = "",
      disabled,
      error,
      onFocus,
      onBlur,
      onKeyDown,
      onPaste,
      disabledOnWheel = false,
      min,
      step,
      max,
      maxLength
    },
    ref
  ) => {
    return (
      <input
        ref={ref}
        id={id}
        spellCheck={false}
        disabled={disabled}
        style={{ boxShadow: "none" }}
        type={type}
        value={value}
        name={name}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
        placeholder={placeholder}
        className={cn(
          "subtext-small h-[40px] flex-1 rounded-[8px] border border-gray-dark-200 bg-background px-3 py-[10px] text-foreground transition-colors placeholder:text-muted-foreground",
          className,
          error ? "border-red-dark-300" : ""
        )}
        onWheel={disabledOnWheel ? (e) => (e.target as HTMLInputElement).blur() : undefined}
        min={min}
        step={step}
        max={max}
        maxLength={maxLength}
      ></input>
    );
  }
);

TextInput.displayName = "TextInput";

export default TextInput;
